
(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('editarEmpleadoController', editarEmpleadoController);


    editarEmpleadoController.$inject = [
        '$stateParams',
        '$templateCache',
        'empleadosService',
        '$scope',
        '$rootScope',
        '$state',
        '$filter',
        '$q',
        'notificationService',
        '$timeout',
        'preferences',
        'simpleModalService',
        'genericDataService',
        'common',
        'uiGridConstants',
        'restrictionService', 
        'modals', 
        'userService'
    ];



    function editarEmpleadoController(
        $stateParams,
        $templateCache,
        empleadosService,
        $scope,
        $rootScope,
        $state,
        $filter,
        $q,
        notificationService,
        $timeout,
        preferences,
        simpleModalService,
        genericDataService,
        common,
        uiGridConstants,
        restrictionService, 
        modals, 
        userService
    ) {
        // jshint maxstatements:false
        
        var id = $stateParams.id;

        var vm = this;
        vm.save = save; 
        vm.activarHorario = false; 
        vm.showContrato = showContrato; 
        vm.deleteContrato = deleteContrato;
        vm.changeActiveContract = changeActiveContract;
        vm.showContratoCallback = showContratoCallback; 
        vm.goBack = goBack; 


        vm.empleado = {}; 
        vm.supervisores = {
           list : [], 
           selected : {}, 
        } ; 

        vm.tiposContrato = ['Indefinido', 'Temporal', 'Prácticas', 'Contratista', 'Agencia', 'Formación y aprendizaje'];
        vm.tiposHoras = ['Diárias', 'Semanales'];
        vm.antiguoActivo = null;
        vm.bloqueado = true; 



        (function () {
            loadData();
        })();

        function loadData() {
            empleadosService.getById(id).then(function(response){
                vm.empleado=response; 
                vm.supervisores.list = vm.empleado.supervisores; 
                vm.supervisores.selected = vm.empleado.usuario != null ? vm.empleado.usuario: null; 
                vm.activarHorario = vm.empleado.activarControlHorario; 
                for(var i = 0; i < vm.empleado.contratos.length; i++) {
                    vm.antiguoActivo = common.isNullOrUndefined(vm.empleado.contratoId) ? 0 : vm.empleado.contratoId; 
                }
                vm.antiguoActivo = vm.empleado.contratoId; 
                vm.bloqueado = vm.empleado.empresa.empresamaster.contrataControlHorario != true; 
            }); 
        }

        function goBack() {
            $rootScope.tabManager.tabs.splice($rootScope.tabManager.tabs.findIndex(x => x.title == 'Editar empleado'), 1);

            $state.go('flota.empleados');
        }

        function save(accion) {
            vm.empleado.usuarioId = vm.supervisores.selected != null ? vm.supervisores.selected.usuarioid : null;
            if(vm.antiguoActivo == 0) {
                sendErrorNotification('Tiene que asignar un contrato al empleado'); 
                return; 
            }
            if(vm.empleado.activarControlHorario == true && vm.activarHorario == false && vm.empleado.registroJornadaId != null) {
                simpleModalService
                 .yesNoModal('Confirmación desactivar', 'Este empleado tiene una jornada activa y procediendo a guardar la eliminará. ¿Está de acuerdo?') // ' + vm.gridApi.selection.vm.gridApi.selection.getSelectedRows() + '
                     .then(function (result) {
                         if (result) {
                             if (checkLicencias()) {
                                 vm.empleado.activarControlHorario = vm.activarHorario;
                                 empleadosService.saveEmpleado({
                                     empleadoId: vm.empleado.empleadoId,
                                     supervisorId: vm.empleado.usuarioId,
                                     activarControlHorario: vm.activarHorario,
                                     contratoId: vm.antiguoActivo
                                 }).then(function (res) {
                                     userService.getUserData().then(function (response) {
                                         if (res == true) sendNotification('El empleado se ha guardado con éxito');
                                         else {
                                             sendErrorNotification('Los empleados con control horario activo superan las licencias contratadas');
                                             vm.activarHorario = false;
                                         }
                                         if (accion == 0 && res == true) {
                                             $rootScope.tabManager.tabs.splice($rootScope.tabManager.tabs.findIndex(x => x.title == 'Editar empleado'), 1);

                                             $state.go('flota.empleados');
                                         }

                                     });
                                 });
                             }
                         } else return;
                     });
            }
            else {
                if (checkLicencias()) {
                    vm.empleado.activarControlHorario = vm.activarHorario;
                    empleadosService.saveEmpleado({
                        empleadoId: vm.empleado.empleadoId,
                        supervisorId: vm.empleado.usuarioId,
                        activarControlHorario: vm.activarHorario,
                        contratoId: vm.antiguoActivo
                    }).then(function (res) {
                        userService.getUserData().then(function (response) {
                            if (res == true) sendNotification('El empleado se ha guardado con éxito');
                            else {
                                sendErrorNotification('Los empleados con control horario activo superan las licencias contratadas');
                                vm.activarHorario = false;
                            }
                            if (accion == 0 && res == true) {
                                $rootScope.tabManager.tabs.splice($rootScope.tabManager.tabs.findIndex(x => x.title == 'Editar empleado'), 1);

                                $state.go('flota.empleados');
                            }

                        });
                    });
                }
            }
           
        }

        function checkLicencias() {
            if(vm.supervisores.selected == null) {
                sendErrorNotification('Tiene que seleccionar un supervisor'); 
                return false; 
            }
            if(vm.empleado.empresa.empresamaster.contrataControlHorario == true 
                && vm.empleado.activarControlHorario == false
                && vm.activarHorario == true
                && vm.empleado.numEmpleadosControlHorario == vm.empleado.empresa.empresamaster.numEmpleadosControlHorario) {
                    sendErrorNotification('Los empleados con control horario activo superan las licencias contratadas');
                    return false;
                }  
            
            return true; 
        }

         function sendErrorNotification(message) {
             notificationService.sendAppNotification({
                 message: message,
                 positionY: 'top',
                 positionX: 'right',
                 delay: 3000,
                 type: 'error'
             });
         }

        function deleteContrato(id) {
            empleadosService.deleteContrato(id).then(function(response){
                if(vm.antiguoActivo == id) vm.antiguoActivo = 0; 
                vm.empleado.contratos.splice(vm.empleado.contratos.findIndex(x=> x.contratoId == id), 1); 
                sendNotification('El contrato se ha eliminado con éxito');
            });
        }

        function sendNotification(message) {
            notificationService.sendAppNotification({
                message: message,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'info'
            });
        }

        function showContrato(contrato) {
            modals.showModal('contrato', vm.showContratoCallback, {
                contrato: contrato,
                empleado: id
            });
        }

        function showContratoCallback() {
            sendNotification('Se ha guardado el contrato con éxito'); 
            empleadosService.getContratos(vm.empleado.empleadoId).then(function(response){
                vm.empleado.contratos = response; 

            }); 
        }

        function changeActiveContract(item) {
            vm.antiguoActivo = item.contratoId;
        }

    }

})();
